import React, { useEffect, useState } from "react";
import { Box } from "rebass";
import { Label, Radio } from "@rebass/forms";
import { useField } from "formik";
import { InputHelper, InputHelperOptionalParameters } from "./InputHelper";
import styled from "styled-components";

export const RadioInput: React.FC<{
  options: any[];
  labels?: string[];
  vertical?: boolean;
  name: string;
  selectedIndex?: number;
  onStateChange?: (selection: any) => void;
  helperParameters?: InputHelperOptionalParameters;
  allowEmpty?: boolean;
}> = ({
  vertical = false,
  options,
  labels,
  name,
  selectedIndex,
  onStateChange,
  helperParameters = { label: name },
  allowEmpty = false,
}) => {
  const validate = (value) => {
    if (value === "" && !allowEmpty) {
      return "Select a value";
    }
  };

  const [, meta, helpers] = useField({ name, validate });

  const { value } = meta;

  const [internalSelectedIndex, setInternalSelectedIndex] = useState(0);

  const setValue = (value: any) => {
    helpers.setValue(value);
    setInternalSelectedIndex(options.indexOf(value));
    if (onStateChange && options.includes(value)) {
      onStateChange(options.indexOf(value));
    }
  };

  useEffect(() => {
    if (
      selectedIndex !== undefined &&
      selectedIndex !== internalSelectedIndex
    ) {
      setValue(options[selectedIndex]);
      // setInternalSelectedIndex(selectedIndex);
    } else if (allowEmpty) {
      setValue(null);
      // setInternalSelectedIndex(-1);
    } else if (selectedIndex === -1) {
      setValue(options[0]);
      // setInternalSelectedIndex(0);
    }
  }, [selectedIndex, options]);

  // useEffect(() => {
  //   if(selectedIndex && selectedIndex !== internalSelectedIndex){
  //     setValue(options[selectedIndex]);
  //     setInternalSelectedIndex(selectedIndex);
  //     console.log("InternalSelectedIndex", internalSelectedIndex);
  //   }
  // }, [selectedIndex,])

  return (
    <InputHelper helpers={helpers} meta={meta} {...helperParameters}>
      <div
        style={{
          display: "flex",
          borderRadius: "default",
          alignItems: "center",
          backgroundColor: "transparent",
        }}
      >
        {allowEmpty ? (
          <StyledOption
            index={0}
            length={options.length}
            selected={null === value}
            onClick={() => {
              setValue(null);
            }}
            key={"option NaN"}
          >
            NaN
          </StyledOption>
        ) : undefined}

        {options.map((option, i) => {
          return (
            <StyledOption
              index={allowEmpty ? i + 1 : i}
              length={options.length}
              selected={
                // option === value
                allowEmpty
                  ? i + 1 === internalSelectedIndex
                  : i === internalSelectedIndex
              }
              onClick={() => {
                setValue(option);
              }}
              key={"option " + option}
            >
              {(labels && labels[i]) || option}
            </StyledOption>
          );
        })}
      </div>
    </InputHelper>
  );
};

const StyledOption = styled.div<{
  index: number;
  length: number;
  selected: boolean;
}>`
  height: 26px;
  margin: ${(props) =>
    "0 " +
    (props.index === props.length - 1 ? 0 : 4) +
    "px 0 " +
    (props.index === 0 ? 0 : 4) +
    "px"};
  padding: 2px 6px 2px 6px;
  border-radius: 3px;
  background-color: ${(props) => (props.selected ? "#3F90B5" : "transparent")};
  color: ${(props) => (props.selected ? "white" : "black")};
  cursor: pointer;
`;
